import { Button } from '@savvy-kit/components/button';
import { Text } from '@savvy-kit/foundations/text';
import { InboxIcon, UploadIcon } from 'lucide-react';

export default function DefaultDropZoneContent({ instructions }: { instructions: string }) {
  return (
    <div className="w-full h-full flex flex-col items-center rounded-sm">
      <div className="border border-light rounded-sm p-2 text-sm text-foreground">
        <InboxIcon size={24} />
      </div>
      <div className="mt-6 mb-6 flex flex-col items-center">
        <Text variant="h3" render={<p />} className="mb-2">
          Add files
        </Text>
        {instructions && <p className="text-sm text-center">{instructions}</p>}
      </div>
      {/* Rendering button as a span to avoid nesting a button inside of a button in the DOM, while preserving the appearance of a button here. */}
      <Button
        render={<span />}
        nativeButton={false}
        className="text-foreground"
        variant="secondary"
        icon={<UploadIcon />}
      >
        Upload files
      </Button>
    </div>
  );
}
